import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SendTestCampaignCard } from './send-test-campaign-card';
import { SendTestCampaignModal } from './send-test-campaign-modal';
import { useSendTestCampaignForm } from './use-send-test-campaign-form';
import { useApiMutation } from '../../../../../../infra/api';
import { endpoints } from '../../../../network';
import { showNotification } from '../../../../../../../app/common/helpers/notifications';
import { useRouteParams } from '../../../../../../infra/routing';
import { useToggle } from '../../../../../../infra/small-tools/use-toggle';
import { useDeliveryChannel } from '../../../hooks';
import { DeliveryChannel } from '../../../../components/delivery-channel-switch';
import { t } from '../../../../../../infra/i18n';
import { ensurePhoneNumberWithCountryCode } from '../../../../../utils/phone-validation';
import { useSession } from '../../../../../../infra/session';
import { getActiveCountry } from '../../../../../../infra/session/selectors';
import { sessionKVStore } from '../../../../../../infra/persistence';
import { EngageTracker } from '../../../../tracking';
import { ENGAGE_CAMPAIGN_TEST_SENT } from '../../../../tracking/events';
export var SendTestCampaignContainer = function () {
    var _a, _b, _c;
    var modalToggle = useToggle(false);
    var session = useSession().data;
    var email = sessionKVStore.getItem('engageTestEmail') || (session === null || session === void 0 ? void 0 : session.user.email) || '';
    var phone = sessionKVStore.getItem('engageTestPhone') || (session === null || session === void 0 ? void 0 : session.user.phone) || '';
    var shopCountry = session ? getActiveCountry(session) || 'US' : 'US';
    var availableDeliveryChannelsOptions = useDeliveryChannel().availableDeliveryChannelsOptions;
    var form = useSendTestCampaignForm({ defaultEmail: email, defaultPhone: phone });
    var control = form.control, handleSubmit = form.handleSubmit, reset = form.reset, errors = form.formState.errors, watch = form.watch;
    var campaignId = useRouteParams().campaignId;
    var hasEmailChannel = availableDeliveryChannelsOptions.some(function (option) { return option.id === DeliveryChannel.EMAIL; });
    var hasSmsChannel = availableDeliveryChannelsOptions.some(function (option) { return option.id === DeliveryChannel.SMS; });
    var _d = watch(), emailValue = _d.email, phoneValue = _d.phone, agree = _d.agree;
    var canSubmit = agree && ((hasEmailChannel && emailValue && !errors.email) || (hasSmsChannel && phoneValue && !errors.phone));
    var _e = useApiMutation({
        endpoint: endpoints.sendPreviewMutation,
        options: {
            onSuccess: function () {
                showNotification({
                    title: t('engage:campaign_builder.send_test.success_title'),
                    message: t('engage:campaign_builder.send_test.success_message'),
                });
                var values = form.getValues();
                if (values.email)
                    sessionKVStore.setItem('engageTestEmail', values.email);
                if (values.phone)
                    sessionKVStore.setItem('engageTestPhone', values.phone);
                modalToggle.setOff();
                reset();
            },
            onError: function () {
                showNotification({
                    title: t('engage:campaign_builder.send_test.error_title'),
                    message: t('engage:campaign_builder.send_test.error_message'),
                });
            },
        },
    }), sendTestCampaign = _e.mutate, isLoading = _e.isLoading;
    var onSubmit = handleSubmit(function (data) {
        var formattedPhone = data.phone ? ensurePhoneNumberWithCountryCode(data.phone) : undefined;
        var deliveryChannels = [];
        if (data.email)
            deliveryChannels.push('email');
        if (data.phone)
            deliveryChannels.push('sms');
        EngageTracker.getInstance().track(ENGAGE_CAMPAIGN_TEST_SENT, {
            campaignId: campaignId,
            sendEmail: !!data.email,
            sendSms: !!data.phone,
        });
        sendTestCampaign({
            campaignId: campaignId,
            email: data.email || undefined,
            phone: formattedPhone,
        });
    });
    if (!hasEmailChannel && !hasSmsChannel)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(SendTestCampaignCard, { onOpen: modalToggle.setOn }), modalToggle.isOn && (_jsx(SendTestCampaignModal, { hasEmailChannel: hasEmailChannel, hasSmsChannel: hasSmsChannel, control: control, isLoading: isLoading, canSubmit: canSubmit, onClose: function () {
                    modalToggle.setOff();
                    reset();
                }, onSubmit: onSubmit, emailErrorMessage: (_a = errors.email) === null || _a === void 0 ? void 0 : _a.message, phoneErrorMessage: (_b = errors.phone) === null || _b === void 0 ? void 0 : _b.message, agreeErrorMessage: (_c = errors.agree) === null || _c === void 0 ? void 0 : _c.message, defaultCountry: shopCountry }))] }));
};
